/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BulkImportVestingTemplateService {

    /**
     * @param taskId
     * @param tenantId
     * @param userId
     * @param taskSpecification
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppBulkImportVestingTemplateBulkImportVestingTemplateProcess(
        taskId?: string,
        tenantId?: string,
        userId?: string,
        taskSpecification?: string,
        requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/bulk-import-vesting-template/bulk-import-vesting-template-process',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'taskSpecification': taskSpecification,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppBulkImportVestingTemplateImportTest(
        formData?: {
            File: Blob;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/bulk-import-vesting-template/import-test',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
